import React from 'react';
import styled from 'styled-components';

interface StackProps extends React.HTMLAttributes<HTMLElement> {
  componentEl?: React.ElementType;
  space?: string | number;
  recursive?: boolean;
  splitAfter?: number;
}

const Stack = ({
  componentEl = 'div',
  children,
  space = 'var(--s0)',
  recursive = false,
  splitAfter = 0,
  ...props
}: StackProps) => {
  const WrapperEl: React.ElementType = componentEl;

  return <WrapperEl {...props}>{children}</WrapperEl>;
};

interface StackAttributes {
  space?: string | number;
  recursive?: boolean;
  splitAfter?: number;
}

export default styled(Stack).attrs<StackAttributes>((props: any) => ({
  space: props.space || 'var(--s0)',
  recursive: props.recursive || false,
  splitAfter: props.splitAfter || 0,
}))<StackAttributes>`
  && {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    > * + * {
      margin-top: ${(props) => props.space};
    }

    > :only-child {
      height: 100%;
    }

    ${(props) =>
      props.splitAfter !== undefined && props.splitAfter > 0
        ? `> :nth-child(${props.splitAfter + 1}) { margin-bottom: auto; }`
        : ''}
  }
`;
